import LoadingIndicator from 'modules/Ui/LoadingIndicator';
import loadable from 'utils/loadable';

const OcrInfoModal = loadable(() => import('./OcrInfoDesktopModal'), {
  fallback: <LoadingIndicator />,
});
export default OcrInfoModal;
